export default function Hero() {
  const chips = ['中文字幕', '字幕在线', '中文版', '国语', '中字', '双语'];

  const jump = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section id="top" className="relative w-full min-h-[560px] md:min-h-[680px] flex items-center">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20dark%20background%20with%20warm%20amber%20and%20deep%20terracotta%20light%20streaks%2C%20blurred%20film%20reel%20textures%20and%20soft%20bokeh%2C%20moody%20atmospheric%20gradient%20with%20subtle%20grain%2C%20elegant%20minimal%20editorial%20art%20direction%2C%20large%20negative%20space%20for%20text%20overlay&width=1920&height=1080&seq=kind-sister-hero-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/80"></div>
      </div>

      <div className="relative z-10 w-full px-5 md:px-10 py-24 md:py-28">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-500 text-foreground-950 text-xs font-medium mb-5">
            <i className="ri-translate-2 text-sm" aria-hidden="true"></i>
            字幕与译制版本信息整理
          </span>
          <h1 className="font-heading font-black text-background-50 text-3xl md:text-5xl leading-tight">
            善良的小姨子在线
          </h1>
          <p className="mt-3 font-heading text-primary-200 text-lg md:text-2xl">
            中文字幕 · 字幕在线 · 中文版 · 国语 · 中字 · 双语
          </p>
          <p className="mt-5 text-background-200 text-sm md:text-base leading-relaxed max-w-2xl">
            本站聚焦《善良的小姨子》的观看语言版本，把中文字幕、字幕在线、中文版、国语配音、中字与双语等常见查找方向整理在一起，
            帮助你在浏览时快速定位自己需要的语言形式，并理解不同版本之间的差别。
          </p>

          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <button
              type="button"
              onClick={() => jump('subtitles')}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
            >
              <i className="ri-list-check-2" aria-hidden="true"></i>
              查看字幕类型
            </button>
            <button
              type="button"
              onClick={() => jump('versions')}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/10 hover:bg-background-50/20 text-background-50 text-sm font-medium border border-background-50/30 whitespace-nowrap transition-colors cursor-pointer"
            >
              <i className="ri-file-list-3-line" aria-hidden="true"></i>
              版本对照
            </button>
          </div>

          <div className="mt-8 flex flex-wrap gap-2">
            {chips.map((chip) => (
              <span
                key={chip}
                className="px-3 py-1.5 rounded-full text-xs text-background-100 bg-background-50/10 border border-background-50/20"
              >
                {chip}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}